module.exports = __webpack_public_path__ + "static/IMG-6-986e9d49fbc60c717013c360e4f5977d.jpg";